import { render, staticRenderFns } from "./CVendorOther.vue?vue&type=template&id=8f570816"
import script from "./CVendorOther.vue?vue&type=script&lang=js"
export * from "./CVendorOther.vue?vue&type=script&lang=js"
import style0 from "./CVendorOther.vue?vue&type=style&index=0&id=8f570816&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f570816')) {
      api.createRecord('8f570816', component.options)
    } else {
      api.reload('8f570816', component.options)
    }
    module.hot.accept("./CVendorOther.vue?vue&type=template&id=8f570816", function () {
      api.rerender('8f570816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CVendorOther.vue"
export default component.exports